import React, { useContext } from "react";

import ImageQuestion from "@/components/ImageQuestion";
import LocaleContext from "@/i18n";

import { Label, LabelWrapper, PollOptionsWrapper, Section } from "./styles";

export type PollBodyProps = {
  multipleChoice?: boolean;
  questionImage?: string;
  children?: React.JSX.Element;
};

export const PollBody: React.FC<PollBodyProps> = (
  props: PollBodyProps
): React.JSX.Element => {
  const { questionImage, multipleChoice } = props;
  const localeContext = useContext(LocaleContext);

  return (
    <Section>
      {questionImage && <ImageQuestion imageUrl={questionImage} />}
      {multipleChoice && (
        <LabelWrapper>
          <Label>{localeContext.translation.pollMultipleChoiceLabel}</Label>
        </LabelWrapper>
      )}
      <PollOptionsWrapper $noMarginTop={!questionImage}>
        {props.children}
      </PollOptionsWrapper>
    </Section>
  );
};
